/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CHECK_INVITE_COUNT } from "../graphql";
import { VApplication } from "../../../application";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { AppNavigatorService } from "../../appNavigatorService";

const log: any = LoggerModule?.getInstance();

const getInfo = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface CheckCountInviteProps { }
export interface ICheckCountInviteMethods extends IPluginMethodMap {
  checkCountInvite(args: CheckCountInviteProps): Promise<any>;
}

export class CheckCountInviteService implements IAgentPlugin {
  readonly methods: ICheckCountInviteMethods;

  constructor() {
    this.methods = {
      checkCountInvite: this.checkCountInvite.bind(this),
    };
  }

  async checkCountInvite() {
    log.blue(`inviteUser server component:`);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      const getEmail = await getInfo()?.getMyProfile();
      const getRole = await getInfo()?.whoAmI();
      if (client) {
        log.blue(` role in checkInvite=====`, getRole);
        if (getRole?.whoami === "admin") {
          return {
            role: "admin",
          };
        }
        if (getRole?.whoami === "superAdmin") {
          return {
            role: "superAdmin",
          };
        }
        const res = await client.query({
          query: CHECK_INVITE_COUNT,
          fetchPolicy: "network-only",
        });
        console.log("payload in service check invite-----", res);

        if (res?.data?.getMyCommitteInviteStatus) {
          let payload = res?.data?.getMyCommitteInviteStatus;
          let sumMaxInvites = 0;
          let sumInviteUsed = 0;

          const contentArray = payload?.content;
          for (const obj of contentArray) {
            if (obj.maxInvites) {
              sumMaxInvites += obj?.maxInvites ?? 0;
            }
            if (obj.inviteUsed) {
              sumInviteUsed += obj?.inviteUsed ?? 0;
            }
          }

          let response = {
            maxCount: sumMaxInvites ?? 0,
            used: sumInviteUsed ?? 0,
          };
          return {
            response,
          };
        }
      }
    } catch (err: any) {
      console.log("error-->", err);
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
